import { HeaderLinksList, HeaderLink } from './NavbarMenuLinks';

import classes from './NavbarMenuBar.module.css'
import logo from '../../images/mrc-logo-colour.png'

function NavbarMenuBar() {
    return (
        <div className={classes.menu_bar}>
            <div className={"navbar container " + classes.mainHeaderStyle}>
                <div className={"nav " + classes.navbarLogoContainer}>
                    <img className={classes.navbarLogo} src={logo} alt="MRC Logo" />
                </div>
                <div className={"nav show " + classes.floatRight + ' ' + classes.navbarText}>
                    <HeaderLinksList>
                        <HeaderLink id="councilWebsite" text="COUNCIL'S WEBSITE" link="http://www.mackay.qld.gov.au/" target="_blank" />
                    </HeaderLinksList>
                </div>
            </div>
        </div>
    );
}

export default NavbarMenuBar;